import { render, staticRenderFns } from "./ControleJustificativa.vue?vue&type=template&id=f91362f4&"
import script from "./ControleJustificativa.vue?vue&type=script&lang=js&"
export * from "./ControleJustificativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports